export const parse = rawData => ({
    linkminer: rawData.linkminer,
    linkminerBeta: rawData.linkminer_beta,
});
